import { createWebHistory, createRouter } from "vue-router"

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/components/Home.vue"),
    meta: { title: "Dashboard" },
  },
  {
    path: "/Tentang-Kami",
    name: "Tentang-Kami",
    component: () => import("@/components/About.vue"),
    meta: { title: "Tentang-Kami" },
  },
  {
    path: "/FAQ",
    name: "FAQ",
    component: () => import("@/components/FAQ.vue"),
    meta: { title: "FAQ" },
  },
  {
    path: "/user-manual",
    name: "user-manual",
    component: () => import("@/components/Usermanual.vue"),
    meta: { title: "User Manual" },
  },
  {
    path: "/pusat-bantuan",
    name: "pusat-bantuan",
    component: () => import("@/components/Pusatbantuan.vue"),
    meta: { title: "User Manual" },
  },
  {
    path: "/InfoTukang",
    name: "InfoTukang",
    component: () => import("@/components/InfoTukang.vue"),
    meta: { title: "InfoTukang" },
  },
  {
    path: "/InfoMaterial",
    name: "InfoMaterial",
    component: () => import("@/components/InfoMaterial.vue"),
    meta: { title: "InfoMaterial" },
  },
  {
    path: "/InfoPeralatan",
    name: "InfoPeralatan",
    component: () => import("@/components/InfoPeralatan.vue"),
    meta: { title: "InfoPeralatan" },
  },
  {
    path: "/InfoProyek",
    name: "InfoProyek",
    component: () => import("@/components/InfoProyek.vue"),
    meta: { title: "InfoProyek" },
  },
  {
    path: "/BadanUsaha",
    name: "BadanUsaha",
    component: () => import("@/components/BadanUsaha.vue"),
    meta: { title: "BadanUsaha" },
  },
  {
    path: "/Terms",
    name: "Terms",
    component: () => import("@/components/Term.vue"),
    meta: { title: "Syarat & Ketentuan" },
  },
  // {
  //   path: "/user/:name",  // <-- notice the colon
  //   name: "User",
  //   component: () => import("@/components/User.vue"),
  //   meta: {title: 'User'},
  //   props: true,
  // },
  {
    path: "/:catchAll(.*)",
    component: () => import("@/components/NotFound.vue"),
    meta: { title: "NotFound" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;